import { render, staticRenderFns } from "./guideDialog.vue?vue&type=template&id=5c724f00&scoped=true"
import script from "./guideDialog.vue?vue&type=script&lang=js"
export * from "./guideDialog.vue?vue&type=script&lang=js"
import style0 from "./guideDialog.vue?vue&type=style&index=0&id=5c724f00&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c724f00",
  null
  
)

export default component.exports